/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { AnalyticsWidget } from '../../../../widgets/analytics-widget-react';

export type IAnalyticsWidgetCompProps = AnalyticsWidget;

export const AnalyticsWidgetComp = ({ ...rest }: IAnalyticsWidgetCompProps) => {
  return (
    <>
      <AnalyticsWidget {...(rest || {})} />
    </>
  );
};

AnalyticsWidgetComp.defaultProps = {};
